/* STEP 3 · rule 4 "ONE LOCK GATE" (owner card 26-Oct-2026; Code Health Report V1 B-4a / B-4c / B-4e) — the W11 header when the
   checklist items are clear and only the lock is blocked, the W12 hint when the lock gate refuses, and the lock refusals in
   Arabic (errors.<CODE>; the English screen shows the server's own sentence). EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S3R4 = {
  en: {
    s3r4: {
      w11ItemsClearLockBlocked: "All clearance items are clear — the file lock is still blocked: see the Lock readiness line below.",
      w12LockRefused: "The file cannot be locked yet:",
    },
    errors: {
      LOCK_FINAL_REPORT_REQUIRED: "The auditor's report must be Final before the file can be locked.",
      W11_CLEARANCE_GATE_RED: "The file cannot be locked: one or more clearance-gate (W11) items are red.",
      SIGNOFF_LOCK_MISSING: "The file cannot be locked: sign-offs (Preparer and Reviewer 1) or completed substantive work are missing — see Lock readiness on File Assembly.",
      W12_REPORT_DATE_REQUIRED: "Enter the date of the auditor's report before marking the file complete.",
    },
  },
  ar: {
    s3r4: {
      w11ItemsClearLockBlocked: "جميع بنود بوابة الاستيفاء سليمة — لكن قفل الملف ما زال ممنوعًا: راجع سطر جاهزية القفل أدناه.",
      w12LockRefused: "لا يمكن قفل الملف بعد:",
    },
    errors: {
      LOCK_FINAL_REPORT_REQUIRED: "يجب أن يكون تقرير المراجع نهائيًا قبل قفل الملف.",
      W11_CLEARANCE_GATE_RED: "لا يمكن قفل الملف: بند أو أكثر من بنود بوابة الاستيفاء (W11) أحمر.",
      SIGNOFF_LOCK_MISSING: "لا يمكن قفل الملف: توقيعات ناقصة (المُعِد والمراجع 1) أو عمل جوهري غير مكتمل — راجع جاهزية القفل في تجميع الملف.",
      W12_REPORT_DATE_REQUIRED: "أدخل تاريخ تقرير المراجع قبل وضع علامة اكتمال الملف.",
    },
  },
};

export default I18N_S3R4;
